'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:env');
}


// default value
exports.isHBNBWebview = false;
exports.platform = 'h5';
exports.appVersion = undefined;
exports.supportPrompt = undefined; // android group 5.x not support alert
exports.HBNBReady = false;

var versionCompare = require('./version-compare.js');
var initEvent = require('./event.js');

var initVersion = function() {
    // user agent regexp
    var RE_ANDROID = (/android/i);
    var RE_IOS = (/iPhone|iPad/i);
    var RE_HBNB = (/\biHotel\/(\d+(?:\.\d+)*)\b/i);
    var TRIP_BIZ = (/mt_trip_biz/i);

    // check user agent
    var ua = navigator.userAgent || '';
    var match = ua.match(RE_HBNB);
    if (match) {
        if (RE_IOS.test(ua)) {
            exports.platform = 'ios';
            exports.appVersion = match[1];
            exports.isHBNBWebview = true;
        } else if (RE_ANDROID.test(ua)) {
            exports.platform = 'android';
            exports.appVersion = match[1];
            exports.isHBNBWebview = true;
            exports.supportPrompt = TRIP_BIZ.test(ua) || Boolean(versionCompare(exports.appVersion, '6.0') >= 0);
        }
    }
};

var init = function() {
    initVersion();
    initEvent();
};

init();

if (process.env.NODE_ENV !== 'production') {
    debug('env = %j', exports);
}



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/invoke/env.js
// module id = 96
// module chunks = 0 8 9